import { Grid, styled, SxProps, Theme } from '@mui/material';

interface PageLayoutContentProps {
    size?: 'sm' | 'md' | 'lg';
    sx?: SxProps<Theme>;
}

export default function Content({ children, size, sx }: React.PropsWithChildren<PageLayoutContentProps>) {
    return (
        <Root size={ 2 }
            contentSize={ size }
            sx={ sx }>
            { children }
        </Root>
    );
}

const Root = styled(Grid, {
    shouldForwardProp: (prop) => prop !== 'contentSize'
})<{ contentSize: 'sm' | 'md' | 'lg' | undefined }>(({ theme, contentSize }) => ({
    margin: '0 auto',
    ...(contentSize ? {
        width: '100%',
        maxWidth: theme.breakpoints.values[contentSize]
    } : {})
}));
